export function getEnvironment(hostname: string) {
  const DEFAULT_ENV = 'production'

  switch (true) {
    case /local/.test(hostname):
      return 'local'
    case /\.info/.test(hostname):
      // eslint-disable-next-line no-case-declarations
      const [environment] = hostname.match(/.+(?=-.+\.gousto\..+)/) || []
      return environment || DEFAULT_ENV
    case /\.co\.uk/.test(hostname):
    default:
      return DEFAULT_ENV
  }
}
